import React, { lazy } from 'react';
const nivel1Summary = ['📚 6 Tomos — toda la carrera organizada', '🎁 6 Bonos — guías, fichas y plantillas'];
const TOMO_7_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779244077/hf_20260520_022247_a584499b-1d28-4431-a430-2c08d4a85a7c_luvc3y.webp';
const TOMO_8_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779244096/hf_20260520_022252_2d9688b9-388c-4b1d-9730-f01bda68780e_nee8aw.webp';
const nivel2Extras = [{
  number: '07',
  title: 'Guardia y Emergencias para el Estudiante',
  desc: 'Las 10 consultas más frecuentes, abordaje de dolor abdominal, disnea, fiebre, shock y cómo presentar un paciente al médico.',
  emoji: '🚨',
  image: TOMO_7_IMG
}, {
  number: '08',
  title: 'Medicina Interna para el Examen',
  desc: 'HTA, diabetes, insuficiencia cardíaca, EPOC, IRC, anemia y los casos clínicos más frecuentes en los finales.',
  emoji: '🩺',
  image: TOMO_8_IMG
}];
const nivel2Summary = ['📚 6 Tomos', '🎁 6 Bonos', '🚨 Tomo 07', '🩺 Tomo 08'];
const editables = [{
  emoji: '📊',
  title: 'Planificador de Carrera'
}, {
  emoji: '📅',
  title: 'Calendario de Parciales'
}, {
  emoji: '📋',
  title: 'Planificador Semanal'
}, {
  emoji: '✅',
  title: 'Tracker de Temas'
}, {
  emoji: '🗓️',
  title: 'Calendario Anual 2025'
}, {
  emoji: '🗺️',
  title: 'Hoja de Ruta del Examen'
}, {
  emoji: '📝',
  title: 'Resumen Rápido de Materia'
}];
const rows = [editables.slice(0, 3), editables.slice(3, 6), editables.slice(6, 7)];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900 relative" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(248,251,255) 0%, rgb(224,242,254) 20%, rgb(186,230,253) 55%, rgb(224,242,254) 75%, rgb(248,251,255) 100%)'
  }} data-id="element-37">
      <div className="mx-auto max-w-4xl" data-id="element-38">

        {/* SISTEMA CARRERA ORGANIZADA */}
        <div className="flex items-center justify-center gap-2 mb-2" data-id="element-39">
          <span className="h-px w-8" style={{
          backgroundColor: '#38bdf8'
        }} data-id="element-40" />
          <p className="text-xs sm:text-sm font-bold tracking-[2px] uppercase m-0" style={{
          color: '#0284c7'
        }} data-id="element-41">
            Un paso más
          </p>
          <span className="h-px w-8" style={{
          backgroundColor: '#38bdf8'
        }} data-id="element-42" />
        </div>

        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-43">
          Sistema Carrera Organizada™
        </h2>
        <p className="text-center text-sm text-gray-600 mx-auto max-w-lg m-0 mb-8" data-id="element-44">
          Todo el Megapack más los tomos clínicos de Guardia y Medicina Interna
          para los años más exigentes de la carrera.
        </p>

        {/* Resumen Nivel 1 incluido */}
        <div className="bg-white/60 rounded-xl px-5 py-3 mb-4" style={{
        border: '1px solid rgba(14,165,233,0.3)'
      }} data-id="element-45">
          <p className="text-xs font-black uppercase tracking-wide m-0 mb-2" style={{
          color: '#0284c7'
        }} data-id="element-46">
            ✅ Ya incluye todo el Nivel 1 — Médico en Proceso™:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-47">
            {nivel1Summary.map(item => <span key={item} className="text-[11px] font-semibold text-gray-600 bg-white rounded-full px-2.5 py-1" style={{
            border: '1px solid rgba(14,165,233,0.25)'
          }} data-id="element-48">
                {item}
              </span>)}
          </div>
        </div>

        {/* Tomos nuevos */}
        <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-10" style={{
        border: '1px solid rgba(2,132,199,0.3)'
      }} data-id="element-49">
          <div className="px-5 py-2.5 flex items-center justify-between gap-3" style={{
          background: 'linear-gradient(135deg, #0369a1 0%, #0284c7 100%)'
        }} data-id="element-50">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-51">
              ⭐ Lo nuevo en este nivel
            </h3>
            <span className="shrink-0 text-[10px] font-bold rounded-full px-2 py-0.5 whitespace-nowrap" style={{
            color: '#bae6fd',
            backgroundColor: 'rgba(2,132,199,0.4)'
          }} data-id="element-52">
              2 Tomos clínicos
            </span>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-53">
            {nivel2Extras.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-54">
                <span className="shrink-0 text-xl w-8 text-center" data-id="element-55">
                  {tome.emoji}
                </span>
                <div className="flex-1 min-w-0" data-id="element-56">
                  <span className="block text-xs font-black text-gray-900" data-id="element-57">
                    Tomo {tome.number} — {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-58">
                    {tome.desc}
                  </span>
                </div>
                <div className="shrink-0 w-16 h-12 rounded-lg overflow-hidden" style={{
              border: '1px solid rgba(14,165,233,0.2)'
            }} data-id="element-59">
                  <img src={tome.image} alt={`Tomo ${tome.number}`} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-60" />
                </div>
              </div>)}
          </div>
        </div>

        {/* Separador hacia Sistema de Gestión Académica */}
        <div className="flex flex-col items-center gap-2 mb-10" data-id="element-61">
          <p className="text-xs font-bold uppercase tracking-widest m-0" style={{
          color: '#0284c7'
        }} data-id="element-62">
            ¿Querés la versión completa?
          </p>
          <p className="text-sm text-gray-600 text-center m-0" data-id="element-63">
            El Sistema de Gestión Académica™ agrega 7 editables premium para
            organizar toda tu carrera.
          </p>
          <div className="flex items-center gap-2 mt-1" data-id="element-64">
            <div className="h-px w-16" style={{
            backgroundColor: '#7dd3fc'
          }} data-id="element-65" />
            <span className="text-lg" style={{
            color: '#38bdf8'
          }} data-id="element-66">↓</span>
            <div className="h-px w-16" style={{
            backgroundColor: '#7dd3fc'
          }} data-id="element-67" />
          </div>
        </div>

        {/* SISTEMA DE GESTIÓN ACADÉMICA — NIVEL 3 */}
        <div className="relative rounded-2xl overflow-hidden shadow-xl mb-6" style={{
        backgroundImage: 'linear-gradient(135deg, rgb(3,55,100) 0%, rgb(2,100,180) 50%, rgb(14,165,233) 100%)',
        border: '2px solid #0ea5e9'
      }} data-id="element-68">
          {/* Header interno */}
          <div className="px-6 pt-8 pb-5 text-center" data-id="element-69">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-70">
              <span className="h-px w-8" style={{
              backgroundColor: 'rgba(186,230,253,0.6)'
            }} data-id="element-71" />
              <p className="text-xs font-bold tracking-[2px] uppercase m-0" style={{
              color: '#bae6fd'
            }} data-id="element-72">
                La versión completa
              </p>
              <span className="h-px w-8" style={{
              backgroundColor: 'rgba(186,230,253,0.6)'
            }} data-id="element-73" />
            </div>
            <h2 className="text-2xl sm:text-3xl font-black text-white m-0 mb-2" data-id="element-74">
              🏆 Sistema de Gestión Académica™
            </h2>
            <p className="text-sm mx-auto max-w-md m-0" style={{
            color: '#e0f2fe'
          }} data-id="element-75">
              Todo el sistema más{' '}
              <strong className="text-yellow-300" data-id="element-76">7 editables premium</strong>{' '}
              para planificar, organizar y dominar cada materia de la carrera.
            </p>
          </div>

          {/* Resumen acumulado */}
          <div className="mx-4 mb-4 rounded-xl px-4 py-3" style={{
          backgroundColor: 'rgba(255,255,255,0.10)',
          border: '1px solid rgba(255,255,255,0.20)'
        }} data-id="element-77">
            <p className="text-xs font-black uppercase tracking-wide m-0 mb-2" style={{
            color: '#bae6fd'
          }} data-id="element-78">
              ✅ Ya incluye todo el Sistema Carrera Organizada™:
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-79">
              {nivel2Summary.map(item => <span key={item} className="text-[11px] font-semibold text-white rounded-full px-2.5 py-1" style={{
              backgroundColor: 'rgba(255,255,255,0.10)',
              border: '1px solid rgba(255,255,255,0.20)'
            }} data-id="element-80">
                  {item}
                </span>)}
            </div>
          </div>

          {/* Editables */}
          <div className="mx-4 mb-4 bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-81">
            <div className="px-5 py-2.5 flex items-center justify-between gap-3" style={{
            background: 'linear-gradient(135deg, #023e6e 0%, #0369a1 100%)'
          }} data-id="element-82">
              <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-83">
                ✏️ Lo nuevo: 7 Editables Premium
              </h3>
              <span className="shrink-0 text-[10px] font-black rounded-full px-2 py-0.5 whitespace-nowrap" style={{
              color: '#1e3a5f',
              backgroundColor: '#fde047'
            }} data-id="element-84">
                EXCLUSIVO
              </span>
            </div>

            <div className="p-4 flex flex-col gap-2" data-id="element-85">
              {rows.map((row, rowIndex) => <div key={rowIndex} className="flex gap-2 justify-center" data-id="element-86">
                  {row.map(item => <div key={item.title} className="flex flex-col gap-1 rounded-lg px-3 py-2.5" style={{
                width: 'calc(33.333% - 6px)',
                backgroundColor: 'rgb(240,249,255)',
                border: '1px solid rgba(14,165,233,0.25)'
              }} data-id="element-87">
                      <span className="text-lg" data-id="element-88">{item.emoji}</span>
                      <span className="text-[11px] font-semibold text-gray-800 leading-snug flex-1" data-id="element-89">
                        {item.title}
                      </span>
                      <span className="text-[10px] font-bold w-fit rounded-full px-2 py-0.5 bg-white" style={{
                  color: '#0284c7',
                  border: '1px solid rgba(14,165,233,0.3)'
                }} data-id="element-90">
                        editable
                      </span>
                    </div>)}
                </div>)}
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 pb-6 text-center" data-id="element-91">
            <p className="text-sm font-black text-yellow-300 m-0 mb-1" data-id="element-92">
              🏆 Todo en un solo lugar — listo para usar desde el día uno
            </p>
            <p className="text-xs m-0" style={{
            color: '#bae6fd'
          }} data-id="element-93">
              La decisión más inteligente para avanzar en Medicina sin perder
              tiempo ni energía.
            </p>
          </div>
        </div>
      </div>

      {/* Degradé de integración con Countdown */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(240,249,255) 100%)'
    }} data-id="element-94" />
    </section>;
}